import React, { useEffect, useState } from "react";
import SiteLayout from "../components/layout/SiteLayout";
import { api, resolveAssetUrl } from "../lib/api";
import { useSettings } from "../lib/settings";

export default function AboutPage() {
  const [pastors, setPastors] = useState([]);
  const { settings } = useSettings();
  useEffect(() => { api.get("/pastors").then((r) => setPastors(r.data)).catch(() => {}); }, []);

  const beliefs = [
    { n: "01", t: settings.belief_1_title, d: settings.belief_1_text },
    { n: "02", t: settings.belief_2_title, d: settings.belief_2_text },
    { n: "03", t: settings.belief_3_title, d: settings.belief_3_text },
    { n: "04", t: settings.belief_4_title, d: settings.belief_4_text },
  ].filter((b) => b.t || b.d);

  return (
    <SiteLayout>
      <section className="container-x py-20 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-5">{settings.about_eyebrow}</div>
            <h1 className="display text-5xl lg:text-7xl">{settings.about_headline}</h1>
          </div>
          <div className="lg:col-span-5 lg:pt-8">
            {settings.about_intro_p1 && (
              <p className="text-[hsl(var(--ink-muted))] leading-relaxed whitespace-pre-line">
                {settings.about_intro_p1}
              </p>
            )}
            {settings.about_intro_p2 && (
              <p className="mt-4 text-[hsl(var(--ink-muted))] leading-relaxed whitespace-pre-line">
                {settings.about_intro_p2}
              </p>
            )}
          </div>
        </div>
      </section>

      {beliefs.length > 0 && (
        <section data-testid="beliefs" className="bg-[hsl(var(--sand))] border-y border-[hsl(var(--line))]">
          <div className="container-x py-20">
            <div className="eyebrow mb-3">{settings.beliefs_eyebrow}</div>
            <h2 className="display text-4xl lg:text-5xl max-w-3xl">{settings.beliefs_headline}</h2>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {beliefs.map((x) => (
                <div key={x.n} className="border-t border-[hsl(var(--ink))] pt-6">
                  <div className="eyebrow text-[hsl(var(--ink-muted))]">{x.n}</div>
                  <div className="display text-3xl mt-3">{x.t}</div>
                  {x.d && (
                    <p className="mt-3 text-sm text-[hsl(var(--ink-muted))] leading-relaxed">{x.d}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section data-testid="pastors-section" className="container-x py-24 lg:py-32">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-14">
          <div>
            <div className="eyebrow mb-3">{settings.pastors_eyebrow}</div>
            <h2 className="display text-4xl lg:text-5xl">{settings.pastors_headline}</h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {pastors.map((p) => (
            <div key={p.id} data-testid={`pastor-${p.id}`} className="grid grid-cols-3 gap-6 items-start">
              <div className="col-span-1">
                <div className="aspect-[3/4] bg-[hsl(var(--sand))] border border-[hsl(var(--line))] overflow-hidden">
                  {p.image_url && (
                    <img src={resolveAssetUrl(p.image_url)} alt={p.name} className="w-full h-full object-cover" />
                  )}
                </div>
              </div>
              <div className="col-span-2">
                <div className="display text-3xl">{p.name}</div>
                <div className="eyebrow mt-2">{p.role}</div>
                <p className="mt-5 text-sm text-[hsl(var(--ink-muted))] leading-relaxed whitespace-pre-line">{p.bio}</p>
              </div>
            </div>
          ))}
          {!pastors.length && (
            <div className="text-sm text-[hsl(var(--ink-muted))]">Our leadership profiles are coming soon.</div>
          )}
        </div>
      </section>
    </SiteLayout>
  );
}
